import common from "./common";
import permissionMapper from "./permissionMapper";

export default {
  mixins: [common, permissionMapper]
};
